<template>
  <BaseTable
    ref="table"
    title="Gruppi Utenti"
    :headers="headers"
    :actions="actions"
    :elevation="0"
    module="customersUsersGroups"
  >
    <template v-slot:actions>
      <v-btn
        v-if="canUser('customers.users_groups', 'create')"
        color="green"
        dark
        tile
        depressed
        @click="openModal"
      >
        Aggiungi
      </v-btn>
    </template>
    <template v-slot:footer>
      <v-dialog
        v-model="dialog"
        max-width="75%"
        :fullscreen="$vuetify.breakpoint.mobile"
        :retain-focus="false"
        @click:outside="modalClose"
      >
        <v-card>
          <v-card-title>Gruppo</v-card-title>
          <v-card-text>
            <CustomerUserGroupForm
              v-if="dialog"
              :edit="editMode"
              @submitted="onSubmitted"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </BaseTable>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import BaseTable from '@components/structure/base-table.vue'
import { createHelpers } from 'vuex-map-fields'
import { authComputed } from '@state/helpers.js'
import CustomerUserGroupForm from '@components/customer_users_groups/CustomerUserGroupForm.vue'

const { mapFields: mapCustomersUsersGroupsFilters } = createHelpers({
  getterType: 'customersUsersGroups/getFiltersFields',
  mutationType: 'customersUsersGroups/SET_FILTER_FIELDS',
})

export default {
  name: 'CustomerUsersGroups',
  components: { CustomerUserGroupForm, BaseTable },
  data() {
    return {
      dialog: false,
      editMode: false,
      headers: [
        {
          text: 'Nome',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Attivo',
          value: 'enabled',
        },
        {
          text: 'Sede',
          value: 'city',
        },
        {
          text: 'Inserito',
          value: 'created_at',
        },
      ],
      actions: [
        {
          label: 'Modifica',
          icon: 'mdi-pencil',
          color: 'primary',
          onItemCondition: () =>
            this.canUser('customers.users_groups', 'update'),
          handler: this.openModal,
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    ...mapState('customers', {
      customer: (state) => state.current,
    }),
    ...mapCustomersUsersGroupsFilters(['customer_id']),
  },
  mounted() {
    this.customer_id = this.customer.id
  },
  beforeDestroy() {
    this.resetFilters()
  },

  methods: {
    ...mapActions('customersUsersGroups', ['removeItem']),
    ...mapMutations('customersUsersGroups', {
      setCurrent: 'SET_CURRENT',
      resetCurrent: 'RESET_CURRENT',
      resetFilters: 'RESET_FILTER_FIELDS',
    }),
    openModal(item) {
      const startingPoint = item.id ? item : { customer_id: this.customer.id }
      // Understand if the modal was opened as editing or for a new sub
      const isEditing = !!startingPoint.id
      this.editMode = isEditing
      this.setCurrent(startingPoint)
      this.dialog = true
    },
    onSubmitted() {
      this.modalClose()
      this.$refs.table.refresh()
    },
    modalClose() {
      this.dialog = false
      this.editMode = false
      this.resetCurrent()
    },
  },
}
</script>
